import axiosInstance from "src/common/axiosInstance";

const workspaceHeaders = (workspaceId) => ({
  headers: workspaceId ? { "X-Workspace-ID": workspaceId } : undefined,
});

export function loadPublicGoogleSheet(workspaceId, url) {
  return axiosInstance.post(
    "/leads/import/google-sheet",
    { url },
    workspaceHeaders(workspaceId)
  );
}

export function importLeadRows(workspaceId, payload) {
  return axiosInstance.post(
    "/leads/import",
    payload,
    workspaceHeaders(workspaceId)
  );
}
